import { getOSSymbolInfo } from "@/canv/utils";
import type { MenuItemsList } from "@/interface/ContextMenu/types";
import { decodeHtml } from "@/shared/lib/decodeHtml";

type TranslateFn = (key: string) => string;

const ACTION_SYMBOL = decodeHtml(getOSSymbolInfo().actionSymbol);
const SUBMENU_SYMBOL = decodeHtml(`&#62`);
const DELETE_SYMBOL = decodeHtml(`&#9003;`);

export const OFFSET = 10;
export const PADDING_SUBMENU = 16;
export const WIDGET_MENU_PADDING = 4;

export const getArrangeSubMenu = (t: TranslateFn) => [
    { label: t("contextMenu.alignLeft"), name: "alignLeft", shortCut: "" },
    { label: t("contextMenu.alignHCenters"), name: "alignHCenters", shortCut: "" },
    { label: t("contextMenu.alignRight"), name: "alignRight", shortCut: "" },
    { label: t("contextMenu.alignTop"), name: "alignTop", shortCut: "" },
    { label: t("contextMenu.alignVCenters"), name: "alignVCenters", shortCut: "" },
    { label: t("contextMenu.alignBottom"), name: "alignBottom", shortCut: "" },
];

export const getMenuItemsList = (t: TranslateFn): MenuItemsList => {
    const arrangeSubMenu = getArrangeSubMenu(t);

    return [
        {
            id: 1,
            name: "copy",
            label: t("contextMenu.copy"),
            shortCut: `${ACTION_SYMBOL} C`,
        },
        {
            id: 2,
            name: "paste",
            label: t("contextMenu.paste"),
            shortCut: `${ACTION_SYMBOL} V`,
        },
        {
            id: 3,
            name: "duplicate",
            label: t("contextMenu.duplicate"),
            shortCut: `${ACTION_SYMBOL} D`,
        },
        { id: 4, name: "lock", label: t("contextMenu.lock") },
        { id: 5, name: "unlock", label: t("contextMenu.unlock") },
        { id: 6, name: "comment", label: t("contextMenu.comment"), shortCut: "C" },
        { id: 7, name: "divider", label: "" },
        {
            id: 8,
            name: "toFront",
            label: t("contextMenu.toFront"),
            shortCut: `${ACTION_SYMBOL} ]`,
        },
        {
            id: 9,
            name: "toBack",
            label: t("contextMenu.toBack"),
            shortCut: `${ACTION_SYMBOL} [`,
        },
        {
            id: 10,
            name: "arrange",
            label: t("contextMenu.arrange"),
            shortCut: SUBMENU_SYMBOL,
            submenu: arrangeSubMenu,
        },
        { id: 11, name: "divider", label: "" },
        {
            id: 12,
            name: "undo",
            label: t("contextMenu.undo"),
            shortCut: `${ACTION_SYMBOL} + Z`,
        },
        {
            id: 13,
            name: "redo",
            label: t("contextMenu.redo"),
            shortCut: `${ACTION_SYMBOL} + Shift + Z`,
        },
        { id: 14, name: "divider", label: "" },
        { id: 15, name: "copyAsPng", label: t("contextMenu.copyAsPng") },
        { id: 16, name: "export", label: t("contextMenu.export") },
        { id: 17, name: "linkToWidget", label: t("contextMenu.linkToWidget") },
        { id: 18, name: "divider", label: "" },
        { id: 19, name: "delete", label: t("contextMenu.delete"), shortCut: DELETE_SYMBOL },
        { id: 20, name: "addSticker", label: t("contextMenu.addSticker"), shortCut: "N" },
        { id: 21, name: "addText", label: t("contextMenu.addText"), shortCut: "T" },
        { id: 22, name: "addShape", label: t("contextMenu.addShape"), shortCut: "S" },
    ];
};
